<script lang="ts">
    import { onMount } from 'svelte';
    import { profileStore } from './profile.store.svelte';
    import MultiSelect from 'svelte-multiselect';
    import Profile from './Profile';

    const profile = new Profile();
    let allSymbols: string[] = $state([]);
    let selected: string[] = $state([]);

    onMount(async () => {
        await profile.getStatus();
        allSymbols = await profile.getSymbols();
        selected = JSON.parse(localStorage.getItem('coinList') || '[]');
    });

    function enableEdit() {
        profileStore.editing = true;
        profileStore.apiKey = '';
        profileStore.secretKey = '';
    }

    function changeCoins() {
        localStorage.setItem('coinList', JSON.stringify(selected));
    }
</script>

<div class="tab-pane active">
    {#if !profileStore.editing}
        <div class="alert alert-info">
            Binance Keys:
            {#if profileStore.hasKeys}
                ✅ <strong>Налаштовано</strong>
            {:else}
                ⚠️ <strong>Не налаштовано</strong>
            {/if}
        </div>
        <button class="btn btn-secondary" onclick={enableEdit}>Редагувати</button>
    {:else}
        <div class="alert alert-secondary d-flex align-items-center gap-2 py-2 px-3 mb-3" style="font-size:0.87rem">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            Ще немає API ключів?
            <a href="https://www.binance.com/uk-UA/my/settings/api-management" target="_blank" rel="noopener noreferrer" class="alert-link">
                Створити на Binance →
            </a>
            <span class="text-muted ms-1">(потрібні права: <strong>Read</strong> + <strong>Futures</strong>)</span>
        </div>

        <form onsubmit={(e) => { e.preventDefault(); profile.saveSettings(); }} class="mt-3">
            <div class="mb-3">
                <label for="apiKey" class="form-label">Binance API Key</label>
                <input id="apiKey" class="form-control" bind:value={profileStore.apiKey} placeholder="Введіть API Key" />
            </div>
            <div class="mb-3">
                <label for="secretKey" class="form-label">Binance Secret Key</label>
                <input id="secretKey" class="form-control" type="password" bind:value={profileStore.secretKey} placeholder="Введіть Secret Key" />
            </div>
            <button type="submit" class="btn btn-primary">Зберегти</button>
            <button type="button" class="btn btn-link" onclick={() => profileStore.editing = false}>Скасувати</button>
        </form>
    {/if}
</div>

{#if allSymbols.length > 0}
    <div class="form-group my-3">
        <label class="form-label">Активні монети:</label>
        <MultiSelect class="form-select" bind:selected onchange={changeCoins} options={allSymbols} />
    </div>
{/if}
